import { render, staticRenderFns } from "./ButtonShare.vue?vue&type=template&id=13ee8981&scoped=true&lang=pug&"
import script from "./ButtonShare.vue?vue&type=script&lang=ts&"
export * from "./ButtonShare.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonShare.vue?vue&type=style&index=0&id=13ee8981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee8981",
  null
  
)

export default component.exports